'use client';

import React from 'react';
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  Cell,
} from 'recharts';

const flightData = [
  { range: '$200–300', count: 8, highlight: false },
  { range: '$300–400', count: 34, highlight: true },
  { range: '$400–500', count: 58, highlight: true },
  { range: '$500–600', count: 72, highlight: true },
  { range: '$600–700', count: 41, highlight: false },
  { range: '$700–800', count: 22, highlight: false },
  { range: '$800+', count: 13, highlight: false },
];

const hotelData = [
  { range: '$50–100', count: 14, highlight: true },
  { range: '$100–150', count: 31, highlight: true },
  { range: '$150–200', count: 22, highlight: false },
  { range: '$200–300', count: 18, highlight: false },
  { range: '$300–400', count: 5, highlight: false },
  { range: '$400+', count: 2, highlight: false },
];

interface Props {
  activeTab: string;
}

const CustomTooltip = ({ active, payload, label }: any) => {
  if (active && payload && payload.length) {
    return (
      <div className="bg-card border border-border rounded-xl px-3 py-2 shadow-card-lg">
        <p className="text-xs font-semibold text-foreground">{label}</p>
        <p className="text-xs text-muted-foreground">
          <span className="font-700 text-primary tabular-nums">{payload[0].value}</span> options
        </p>
      </div>
    );
  }
  return null;
};

export default function PriceHistogram({ activeTab }: Props) {
  const data = activeTab === 'hotels' ? hotelData : flightData;

  return (
    <div className="bg-card border border-border rounded-2xl p-4 mb-4">
      <div className="flex items-center justify-between mb-3">
        <div>
          <p className="text-sm font-700 text-foreground">Price Distribution</p>
          <p className="text-xs text-muted-foreground">
            {activeTab === 'flights' ? 'Per person, round trip' : 'Per night, before taxes'}
          </p>
        </div>
        <span className="text-xs text-muted-foreground">
          Shaded = your price range
        </span>
      </div>
      <ResponsiveContainer width="100%" height={80}>
        <BarChart data={data} barSize={24} margin={{ top: 0, right: 0, left: 0, bottom: 0 }}>
          <XAxis
            dataKey="range"
            tick={{ fontSize: 10, fill: 'var(--muted-foreground)' }}
            axisLine={false}
            tickLine={false}
          />
          <YAxis hide />
          <Tooltip content={<CustomTooltip />} cursor={{ fill: 'var(--muted)', opacity: 0.4 }} />
          <Bar dataKey="count" radius={[4, 4, 0, 0]}>
            {data.map((entry, index) => (
              <Cell
                key={`cell-${index}`}
                fill={entry.highlight ? 'var(--primary)' : 'var(--muted)'}
                fillOpacity={entry.highlight ? 1 : 0.6}
              />
            ))}
          </Bar>
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
}